realmCommerceApp.controller("SearchController", SearchController);

/*@ngInject*/
function SearchController($window, $timeout, $filter, customerService, loaderService, apiService, gtmEcommerceService, searchData, productGroups, hiddenCategories) {
    let vm = this;
    vm.customer = customerService.getCustomerPreview();
    vm.showFilterGroup = showFilterGroup;
    vm.mustShowModifier = mustShowModifier;
    vm.searchModel = {
        term: '',
        categoryId: '',
        categoryName: '',
        size: 10,
        filterSize: 10,
        page: 0,
        pagination: 1,
        sortType: 'relevancy',
        sortOrder: 'asc',
        modifiers: {},
    };

    vm.searchSizeOptions = [
        {id: 10, name: 10},
        {id: 20, name: 20},
        {id: 30, name: 30},
        {id: 40, name: 40},
        {id: 50, name: 50},
        {id: 100, name: 100},
    ];

    vm.searchSortByTypeOptions = [
        {id: 'relevancy', name: 'Relevancy', sortOrder: 'asc', type: 'relevancy'},
        {id: 'gross_desc', name: 'Price: high to low', sortOrder: 'desc', type: 'gross'},
        {id: 'gross_asc', name: 'Price: low to high', sortOrder: 'asc', type: 'gross'},
    ];

    vm.search = search;
    vm.applyFilter = applyFilter;
    vm.removeFilter = removeFilter;
    vm.clearFilters = clearFilters;
    vm.pageChanged = pageChanged;
    vm.createValue = createValue;
    vm.getCategoryName = getCategoryName;
    vm.isModifiersEmpty = isModifiersEmpty;
    vm.canShowCategory = canShowCategory;
    vm.shortenText = shortenText;
    vm.currentModifiers = null;
    vm.loadMoreFilters = loadMoreFilters;
    vm.isProductAlreadyPurchased = isProductAlreadyPurchased;
    vm.isHiddenCategory = isHiddenCategory;
    activate();

    function activate() {
        vm.customer = customerService.getCustomerPreview();
        if (typeof searchData === 'undefined') {
            return;
        }
        vm.searchModel = angular.merge(vm.searchModel, angular.copy(searchData));
        if (vm.searchModel.modifiers.publisher) {
            vm.searchModel.modifiers.publisher = decodeURIComponent(vm.searchModel.modifiers.publisher);
        }
        const selectedOption = vm.searchSortByTypeOptions.find(option => option.type === vm.searchModel.sortType && option.sortOrder === vm.searchModel.sortOrder);
        if (selectedOption !== null) {
            vm.searchModel.sortType = selectedOption.id;
        }
        vm.currentModifiers = angular.copy(vm.searchModel.modifiers);
        vm.searchTerm = searchData.term;
        vm.searchModel.pagination.page = vm.searchModel.pagination.page + 1;
        angular.forEach(vm.searchModel.navigations, (navigation, key) => {
            vm.searchModel.navigations[key].filterSize = 10;
        });
        updateNavigation();
        addImpressions();

        setTimeout(() => {
            angular.element('.selectpicker').selectpicker('refresh');
            angular.element('.bootstrap-select').find('button[type=button].bs-placeholder').remove();
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
                angular.element('.selectpicker').selectpicker('mobile');
            }
        }, 100);
    }

    function addImpressions() {
        gtmEcommerceService.sendImpressions(vm.searchModel.items, 'productDetails');
    }

    function updateNavigation() {
        angular.forEach(vm.searchModel.navigations, (navigation, key) => {
            vm.searchModel.navigations[key].buckets = vm.searchModel.navigations[key].buckets.filter((bucket) => {
                if (bucket.key === vm.searchModel.modifiers[key]) {
                    return false;
                }
                if (key === "productgroups") {
                    if (!vm.canShowCategory(key, bucket.key)) {
                        return false;
                    }
                    if (vm.searchModel.modifiers[key]) {
                        if (bucket.key.split(',').length === 1 && bucket.key !== vm.searchModel.modifiers[key]) {
                            return false;
                        }
                        if (bucket.key.split(',').length > 1 && bucket.key.split(',')[0] !== vm.searchModel.modifiers[key]) {
                            return false;
                        }
                    }
                }
                return true;
            });

            if (!vm.searchModel.navigations[key].buckets.length) {
                delete vm.searchModel.navigations[key];
            }
        });
        moveContributorNavigatorToTop();
    }

    function moveContributorNavigatorToTop() {
        if (vm.searchModel.navigations['contributor']) {
            let contributorNavigator = Object.assign(vm.searchModel.navigations['contributor']);
            delete vm.searchModel.navigations['contributor'];
            let oldNavigation = Object.assign(vm.searchModel.navigations);
            vm.searchModel.navigations = Object.assign({contributor: contributorNavigator}, oldNavigation);
        }
    }

    function canShowCategory(key, bucketKey) {
        return key === 'productgroups' &&
            (
                ((vm.currentModifiers[key] !== bucketKey.key && vm.currentModifiers[key] && vm.currentModifiers[key]) ||
                    (!bucketKey.includes(',') && !vm.currentModifiers[key])) ||
                vm.currentModifiers[key] === bucketKey
            );
    }

    function search() {
        loaderService.start();
        vm.searchModel.pagination.page = vm.searchModel.pagination.page - 1;
        if (vm.customer !== null) {
            vm.searchModel.customerId = vm.customer.entity_id;
        }

        let url = '/search?term=' + vm.searchModel.term;

        url += "&page=" + vm.searchModel.pagination.page || 0;
        url += "&size=" + vm.searchModel.size;

        if (vm.searchModel.sortType) {
            const selectedSortOption = vm.searchSortByTypeOptions.find(option => option.id === vm.searchModel.sortType);
            if (selectedSortOption !== null) {
                url += "&sortType=" + selectedSortOption.type;
                url += "&sortOrder=" + selectedSortOption.sortOrder;
            }
        }

        if (!isModifiersEmpty(vm.searchModel.modifiers)) {
            if (vm.searchModel.modifiers.publisher) {
                vm.searchModel.modifiers.publisher = encodeURIComponent(vm.searchModel.modifiers.publisher);
            }
            url += "&modifiers=" + JSON.stringify(vm.searchModel.modifiers);
        }
        window.location = url;
    }

    function loadMoreFilters(modifier) {
        apiService.productFilterSearch(vm.searchModel, (vm.searchModel.navigations[modifier].buckets.length + 15)).then((data) => {
            vm.searchModel.navigations[modifier] = data.navigations[modifier];
            vm.searchModel.navigations[modifier].filterSize = (vm.searchModel.navigations[modifier].buckets.length);
            updateNavigation();
            $timeout(() => {
                angular.element('.buckets.' + modifier)[0].scrollTop = angular.element('.buckets.' + modifier)[0].scrollHeight;
            }, 0);
        });
    }

    function applyFilter(type, value) {
        eval('vm.searchModel.modifiers.' + type + ' = value;');
        search();
    }

    function removeFilter(type) {
        delete vm.searchModel.modifiers[type];
        search();
    }

    function clearFilters() {
        vm.searchModel.modifiers = [];
        search();
    }

    function pageChanged() {
        search();
    }

    function getCategoryName(key) {
        let groupIds = key.split(",");
        let selectedGroupId = groupIds[groupIds.length - 1];
        productGroups.forEach((productGroup) => {
            if (productGroup.entity_id == selectedGroupId) {
                key = productGroup.label;
            }
        });
        return key;
    }

    function showFilterGroup(key, value) {
        return !(value.buckets.length == 1 && value.buckets.find(b => createValue(b.key, key) == ''));
    }

    function mustShowModifier(key, value) {
        return createValue(key, value) !== '';
    }

    function createValue(value, key) {
        if (key == 'productgroups') {
            value = getCategoryName(value);
        }
        if (key == 'gross_range') {
            if ((value.indexOf('-') != -1)) {
                let range = value.split("-");
                value = $filter('currency')(range[0]) + ' - ' + $filter('currency')(range[1]);
            } else {
                value = $filter('currency')(value) + '+';
            }
        }
        return value;
    }

    function isModifiersEmpty(obj) {
        return Object.keys(obj).length == 0
    }

    function shortenText(text, textLength) {
        if (text.length > textLength) {
            text = text.substr(0, textLength) + '...';
        }
        return text;
    }

    function isProductAlreadyPurchased(entityId) {
        return customerService.isProductAlreadyPurchased(entityId);
    }

    function isHiddenCategory(category){
        return hiddenCategories.includes(category);
    }

}



// WEBPACK FOOTER //
// ./static/js/app/search/search.controller.js